import { Box, Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { Showroom } from '_app/graphql/generated/graphql'

interface ShowroomProps {
  showroom: Showroom;
}

const ShowroomInfo = ({ showroom }: ShowroomProps) => {
  const { t } = useTranslation('checkout')

  return (
    <Box textStyle="bodyLight">
      <Text>{showroom?.address}</Text>
      <Flex justifyContent="space-between">
        <Text>{`${t('WEEKDAYS', { ns: 'common' })}:`}</Text>
        <Text>{showroom?.open_hours?.monday}</Text>
      </Flex>
      <Flex justifyContent="space-between">
        <Text>{`${t('SATURDAY', { ns: 'common' })}:`}</Text>
        <Text>{showroom?.open_hours?.saturday}</Text>
      </Flex>
      <Flex justifyContent="space-between">
        <Text>{`${t('SUNDAY', { ns: 'common' })}:`}</Text>
        <Text>
          {showroom?.open_hours?.sunday !== null
            ? showroom?.open_hours?.sunday
            : t('CLOSED')}
        </Text>
      </Flex>
    </Box>
  )
}

export default ShowroomInfo
